import React from 'react';
import { Menu } from 'antd';
import menuItem from './menuItem';
import subMenu from './subMenu';
import { useTranslation } from 'react-i18next';
import userHaveRolePermission from '../../../helpers/userHaveRolePermission';
import { useSelector } from 'react-redux';

export default (name = '', path = '', item) => {
  const { t } = useTranslation(['routes']);
  const userRoles =
    useSelector((state) => state.auth?.userIntrospect?.resources) ?? null;
  const showMenu = () => {
    let permission = false;
    Object.keys(userRoles).forEach((key) => {
      item.routes.forEach((childRoute) => {
        if (key === childRoute.name) {
          permission = true;
        }
      });
    });
    return permission;
  };

  return showMenu() ? (
    <Menu.SubMenu
      key={path}
      title={t(`${name}${item.name}.title`)}
      icon={item.icon ? <item.icon /> : null}
    >
      {item.routes
        .filter((x) => x.menu !== false)
        .map((x) =>
          x.routes
            ? subMenu(`${name}${item.name}.`, `${path}${x.path}`, x)
            : menuItem(`${name}${item.name}.`, `${path}`, x),
        )}
    </Menu.SubMenu>
  ) : null;
};
